<section class="bg-secondary-subtle search-overview">
  <header class="pt-topbar text-bg-secondary dotted-bg">
    <!-- pb-5 pb-lg-6 -->
    <div class="container section-inset-t text-max-width-sm text-center">
      <h1 class="h2">{{ 'zoek-overzicht-titel' | fromDictionary }}</h1>

      <app-search-field [initialQuery]="q()"></app-search-field>

      <div class="search-query-meta py-3 fs-body-md">
        @if (q()) {
          <span class="fw-normal">
            {{ resultCount() }} {{ resultCount() > 1 ? 'resultaten voor' : 'resultaat voor' }}
            <strong class="fw-bold text-accent break-word d-inline-block">{{ q() }}</strong>
          </span>
          <!--<span class="fw-normal text-accent">{{ resultCount() }} resultaten</span>-->
        }
      </div>
    </div>
  </header>
  <main class="container py-4 py-lg-5">
    @if (!q()) {
      <section class="text-center text-max-width-sm mx-auto">
        <h2 class="fs-body-sm fw-normal mb-3">{{ 'zoek-overzicht-populair-suggesties-titel' | fromDictionary }}</h2>
        <app-menu-button-cloud [menuItems]="'zoek-suggesties' | fromMenu" cssClasses="justify-content-center"></app-menu-button-cloud>
      </section>
    }

    @if (loading$()) {
      <section class="text-center text-max-width-sm mx-auto mb-5">
        <app-loading-indicator class="text-secondary" [loading]="true" [type]="'standalone'"></app-loading-indicator>

        <p class="mb-0 mt-3 text-body-secondary">{{ 'zoek-overzicht-laden-tekst' | fromDictionary }}</p>
      </section>
    }

    @if (q() && resultCount() === 0 && !loading$()) {
      <section class="row gutter-y-3">
        <div class="col-md-12 offset-lg-2 col-lg-10">
          <div class="card p-3 p-xxsm-4">
            <h2 class="h5">{{ 'zoek-overzicht-niks-gevonden-titel' | fromDictionary }}</h2>
            <p [innerHTML]="'zoek-overzicht-niks-gevonden-tekst' | fromDictionary"></p>

            <div class="d-flex gap-1 flex-wrap mt-2">
              <a [routerLink]="['/contact']" class="button button--secondary">
                <span>{{ 'zoek-overzicht-niks-contact-knop-tekst' | fromDictionary }}</span>
              </a>
              <a [routerLink]="['/zoeken']" class="button button--secondary-subtle">
                <span>{{ 'zoek-overzicht-niks-reset-knop-tekst' | fromDictionary }}</span>
              </a>
            </div>
          </div>
        </div>
        <div class="col-md-12 col-lg-10">
          <div class="card p-3 p-xxsm-4">
            <h2 class="h5 mb-3">{{ 'zoek-overzicht-populair-suggesties-titel' | fromDictionary }}</h2>
            <app-menu-button-cloud [menuItems]="'zoek-suggesties' | fromMenu"></app-menu-button-cloud>
          </div>
        </div>
      </section>
    }

    @if (resultCount() > 0 && q()) {
      <div class="row gutter-x-lg-5 gutter-y-5">
        <div class="col-md-12" [ngClass]="!events().length ? 'd-none d-md-block' : ''">
          <div class="search-overview-column-header">
            <h2 class="h4">{{ 'zoek-overzicht-resultaten-agenda-titel' | fromDictionary }}</h2>

            <a class="mb-n1 button button-link button--secondary h-auto button--xs" [routerLink]="['/agenda']" [queryParams]="{ q: q() }">
              <fstr-icon anchor="line-icon-sliders"></fstr-icon>
              <span>Uitgebreid zoeken</span>
            </a>
          </div>
          <ul class="row gutter-2" [@CardGridAnimation]="maxEventsShown()">
            @for (event of events() | slice: 0 : maxEventsShown(); track event.id) {
              <app-event-card class="col-sm-12 col-md-24 col-lg-12 d-block" [event]="event" [inList]="true"></app-event-card>
            }
            @if (!events().length) {
              <p class="ps-1">{{ 'zoek-overzicht-resultaten-agenda-geen-resultaat' | fromDictionary }}</p>
            }
          </ul>

          @if (events().length > maxEventsShown()) {
            <div class="text-center pt-3">
              <button class="button button--secondary-subtle gap-0 button--xs" (click)="maxEventsShown.set(maxEventsShown() + 5)">
                <fstr-icon class="icon-xs me-1" anchor="line-icon-plus"></fstr-icon>
                <span>{{ 'zoek-overzicht-resultaten-agenda-toon-meer' | fromDictionary }}</span>
              </button>
            </div>
          }
        </div>

        <div class="col-md-12 d-flex flex-column gap-5">
          <section [ngClass]="!faq().length ? 'd-none d-md-block' : ''">
            <header class="search-overview-column-header">
              <h2 class="h4">{{ 'zoek-overzicht-resultaten-faq-titel' | fromDictionary }}</h2>
            </header>

            @if (faq().length > 0) {
              <app-faq-accordion
                [cookiePreferences]="cookiePreferences$() || undefined"
                [faqItems]="faq() | slice: 0 : maxFaqShown()"
                [@CardGridAnimation]="maxFaqShown()"
              ></app-faq-accordion>
            } @else {
              <p class="ps-1">{{ 'zoek-overzicht-resultaten-faq-geen-resultaat' | fromDictionary }}</p>
            }

            @if (faq().length > maxFaqShown()) {
              <div class="text-center pt-3">
                <button class="button button--secondary-subtle gap-0 button--xs" (click)="maxFaqShown.set(maxFaqShown() + 5)">
                  <fstr-icon class="icon-xs me-1" anchor="line-icon-plus"></fstr-icon>
                  <span>{{ 'zoek-overzicht-resultaten-faq-toon-meer' | fromDictionary }}</span>
                </button>
              </div>
            }
          </section>
          <section [ngClass]="!pages().length ? 'd-none d-md-block' : ''">
            <header class="search-overview-column-header">
              <h2 class="h4">{{ 'zoek-overzicht-resultaten-paginas-titel' | fromDictionary }}</h2>
            </header>
            <ul class="row gutter-1" [@CardGridAnimation]="maxPagesShown()">
              @for (page of pages() | slice: 0 : maxPagesShown(); track page.id) {
                <app-page-list-card
                  class="col-24 d-block"
                  [image]="page.image"
                  [title]="page.title"
                  [date]="page.startDate"
                  [type]="page.subtitle || page.mutedSubtitle"
                  [routerLink]="page.routerLink"
                ></app-page-list-card>
              }

              @if (!pages().length) {
                <p class="ps-1">{{ 'zoek-overzicht-resultaten-paginas-geen-resultaat' | fromDictionary }}</p>
              }
            </ul>

            @if (pages().length > maxPagesShown()) {
              <div class="text-center pt-3">
                <button class="button button--secondary-subtle gap-0 button--xs" (click)="maxPagesShown.set(maxPagesShown() + 5)">
                  <fstr-icon class="icon-xs me-1" anchor="line-icon-plus"></fstr-icon>
                  <span>{{ 'zoek-overzicht-resultaten-paginas-toon-meer' | fromDictionary }}</span>
                </button>
              </div>
            }
          </section>
        </div>
      </div>
    }
  </main>
</section>
